import React, { FC, useState, useEffect } from "react";
import { Dialog, DialogContent, DialogTitle, Typography, IconButton, Box } from "@mui/material";
import { Search, FormatListBulleted, Close } from "@mui/icons-material";
import { GridColDef, GridColumnHeaderParams, GridRenderCellParams } from "@mui/x-data-grid";
import { CustomDataGrid } from "../CustomDataGrid";
import { getAxios } from "../../utils/endpoints";

type IProps = {
    productId: string;
    zipCode: string;
    isOpen: boolean;
    onClose: () => void;
}

type PossibleDealer = {
    id: string;
    name: string;
}

const defaultColumnOptions = {
    resizable: false,
    flex: 1,
    hideSortIcons: false,
    disableColumnMenu: false,
}


const CoverageDatagrid: FC<{ productId: string, zipCode: string }> = (props) => {
    const [possibleDealers, setPossibleDealers] = useState<PossibleDealer[]>([]);

    const onFetchPossibleCoverages = async (): Promise<void> => {
        const response = await getAxios(`/dealers/cover`, "GET", undefined, {
            product: props.productId,
            zip: props.zipCode
        });

        const data = await response.data;

        if (!data) {
            return;
        }

        const possibleCoverages: PossibleDealer[] = await data.map((val: any) => {
            return {
                id: val.username,
                name: val.companyName
            }
        });

        setPossibleDealers(possibleCoverages);
    }

    useEffect(() => {
        onFetchPossibleCoverages();
    }, [props.productId, props.zipCode]);

    const columns: GridColDef[] = [
        {
            field: "id",
            headerName: "Id",
            headerAlign: "center",
            align: "center",
            renderHeader: (params: GridColumnHeaderParams) => {
                return (
                    <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
                        {params.colDef.headerName!}
                    </Typography>
                );
            },
            renderCell: (params: GridRenderCellParams) => {

                return (
                    <Box sx={{ mt: 1, mb: 1 }} >
                        <Typography sx={{ fontWeight: 400, fontSize: 14 }} >
                            {params.value}
                        </Typography>
                    </Box>
                )
            },
            ...defaultColumnOptions
        },
        {
            field: "name",
            headerName: "Name",
            headerAlign: "center",
            align: "center",
            renderHeader: (params: GridColumnHeaderParams) => {
                return (
                    <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
                        {params.colDef.headerName!}
                    </Typography>
                );
            },
            renderCell: (params: GridRenderCellParams) => {

                return (
                    <Box sx={{ mt: 1, mb: 1 }} >
                        <Typography sx={{ fontWeight: 400, fontSize: 14 }} >
                            {params.value}
                        </Typography>
                    </Box>
                )
            },
            ...defaultColumnOptions
        }
    ];

    return (
        <CustomDataGrid columns={columns} rows={possibleDealers} sortingOrder={["asc", "desc"]} />
    )
}

export const CoverageDealers: FC<IProps> = (props): JSX.Element => {
    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={props.isOpen}
            onClose={props.onClose}
        >
            <DialogTitle sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }} >
                <Typography fontSize={22} fontWeight="600" color="#1BA0E9" textAlign="center">
                    Coverage Dealers
                </Typography>
                <IconButton onClick={props.onClose} >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <CoverageDatagrid productId={props.productId} zipCode={props.zipCode} />
            </DialogContent>
        </Dialog>
    )
}